/**
 * Animist rule overrides.
 *
 * Card text (verbatim from sorcery-cards.json):
 *   "Tap → Play or draw a site.
 *
 *    You may cast magics in your hand as Spirits with power equal to
 *    their cost."
 *
 * The Tap line is the standard avatar builtin. Handled in
 * GameBoard._activatedEntriesFor as the `avatar_site` builtin.
 *
 * The second clause is a passive type-extension. Every Magic card in
 * the Animist's controller's hand can also be played as a Spirit
 * Minion whose attack and defence both equal the card's cost. The
 * actual transform is a pure helper at
 * `engine/automation/ops/animistSpirit.js`, applied by GameBoard at
 * the hand → table boundary so the Magic enters the realm already
 * typed as a Minion with the Spirit subtype and a derived statline.
 *
 * It's a "may", not an always-on conversion: the player opts in via the
 * `__builtin_animist_spirit` activated ability, which arms a one-shot
 * "the next magic I play this turn enters as a Spirit." `castMagicAsSpirit`
 * stays the eligibility predicate (this avatar CAN do it); the transform
 * only fires while the arm flag is set (see cardPileLifecycle). No tap /
 * mana cost and repeatable. Re-arm before each magic you want to summon.
 */
export const ANIMIST_RULES = {
  castMagicAsSpirit: true,
  extraActivatedAbilities: [
    {
      id: '__builtin_animist_spirit',
      _builtin: 'animist_spirit',
      trigger: 'activated',
      cost: [],
      description: 'Summon a magic as a Spirit',
    },
  ],
};
